import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './BrowseLookSwiperNewUI.css';
import { Navigation, Pagination, Parallax } from 'swiper/modules';
import { Box, Button, Card, Chip, Divider, Grid, Modal, Typography } from '@mui/material';
// import InstagramEmbed from './InstagramEmbed';
import { InstagramEmbed } from 'react-social-media-embed';
import InstagramEmbedPermalink from './InstagramEmbedNew';


import Caption from './Caption';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { FaChartLine, FaChevronLeft, FaUser } from 'react-icons/fa';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useNavigate } from 'react-router-dom';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PinterestIcon from "@mui/icons-material/Pinterest";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ShowcaseLookCard from './ShowcaseLookCard';
import { motion } from 'framer-motion';

export default function BrowseLookSwiperInfluenersNewUI({selectedTab, image_info, showAll }) {
  const isInfluencerTab = selectedTab.param === "featured_influencer";
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLook, setSelectedLook] = useState(null);
  const navigate = useNavigate() 
  

  
  


  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLook(null);
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 12.5 },
    visible: index => ({ opacity: 1, y: 0, transition: { delay: index * 0.05, type: 'linear', stiffness: 100 } }),
    // hover: { scale: 1.03, boxShadow: '0px 5px 10px rgba(0,0,0,0.15)' }
  };


  return (
    <>

<Box 
     sx={{
      height:'65vh',
      p:1,
      display:'flex',
      overflowY: 'scroll',
      flexDirection:'column',
      justifyItems:'center',
      // justifyContent:'center',
      alignItems:'center'


     }}
     >
     
   
  { (showAll ? image_info : image_info.slice(0, 7)).map((item, index) => (
   
    
    <motion.div
    key={item.id}
    custom={index}
    variants={itemVariants}
    initial="hidden"
    animate="visible"
    whileHover="hover"
    // style={{ width: '100%' }}
    >
    <Box
    display={'flex'}
    flexDirection={'column'}
    // gap={1}
    padding={1}
    m={1}
    sx={{
      // backgroundColor:'rgba(1,1,1,1)',
      
      border:'1px solid rgb(0, 0, 0)',
      // objectFit:'cover',
      borderRadius:3,
      height:'auto',
      // minHeight:'25dvh',
      maxHeight:'484px',
      // width:'100%',
      // m:1
    }}
    >
    
      <InstagramEmbedPermalink url={item.permalink}/>
      <Box>
       <Button

              //  color="primary"
               sx={{
                 backdropFilter: 'blur(5px)',
                 borderRadius: 2,
                 backgroundColor: 'rgba(1, 1, 1, 0.1)',
                //  border: '1px solid rgba(1, 1, 1, 0.25)',
               }}
               onClick={()=>{
                navigate('/shop-the-post', {state:{
                  id:item.id,
                  media_id: item.media_id,
                  permalink:item.permalink,
                  username:item.username
                }})
               }}
               startIcon={<ShoppingCartIcon/>}
            
               fullWidth
               variant="text"
             >
               
               <Typography
                 textTransform={'capitalize'}
                 fontWeight={'bold'}
                 variant="body1"
                 color="black"
                 fontSize={'0.9rem'}
                 // p={1}
               >
                 Shop The Look
               </Typography>
             </Button>
    
      </Box>

      </Box>
      </motion.div>
   
  ))}


</Box>


  

    </>
  );
}

